export function netMinutes(shift) {
  if (!shift?.start_time || !shift?.end_time) return 480;
  const [sh, sm] = shift.start_time.split(":").map(Number);
  const [eh, em] = shift.end_time.split(":").map(Number);
  let mins = (eh * 60 + em) - (sh * 60 + sm);
  if (mins <= 0) mins += 1440; // gece vardiyası
  return mins - (shift.breaks || []).reduce((a, b) => a + (Number(b.minutes) || 0), 0);
}
